export const validatorPositive = value => {
  if (value >= 0) {
    return true
  }
  return false
}

export const validatorPassword = password => {
  /* eslint-disable no-useless-escape */
  // Requisitos: 8-12 caracteres, al menos una mayúscula, un número y un carácter especial (@#$%&)
  const regExp = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%&]).{8,12}$/
  /* eslint-enable no-useless-escape */
  const validPassword = regExp.test(password)
  return validPassword
}

export const passwordRequirements = {
  length: (password) => password.length >= 8 && password.length <= 12,
  uppercase: (password) => /[A-Z]/.test(password),
  number: (password) => /[0-9]/.test(password),
  symbol: (password) => /[@#$%&]/.test(password),
}

export const validatorCreditCard = creditnum => {
  /* eslint-disable no-useless-escape */
  const cRegExp = /^(?:3[47][0-9]{13})$/
  /* eslint-enable no-useless-escape */
  const validCreditCard = cRegExp.test(creditnum)
  return validCreditCard
}

export const validatorUrlValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
  /* eslint-enable no-useless-escape */
  return re.test(val)
}
